module.exports = __webpack_public_path__ + "static/028.thumb-7cbb56215ef7290c447c6314d3071101.jpg";